
import IconYoutube from '~/components/icons/IconYoutube.vue';
import IconFacebook from '~/components/icons/IconFacebook.vue';
import IconInstagram from '~/components/icons/IconInstagram.vue';
import IconPinterest from '~/components/icons/IconPinterest.vue';

export default {
  components: {
    IconYoutube,
    IconFacebook,
    IconInstagram,
    IconPinterest,
  },
  data: () => ({
    socials: [
      {
        link: 'https://www.facebook.com/ParkosInternational/',
        icon: 'icons-icon-facebook',
        active: true,
      },
      {
        link: 'https://www.youtube.com/c/ParkosInternational/',
        icon: 'icons-icon-youtube',
        active: true,
      },
      {
        link: 'https://twitter.com/ParkosInt/',
        icon: 'icons-icon-twitter',
        active: false,
      },
      {
        link: 'https://www.instagram.com/parkos.international/',
        icon: 'icons-icon-instagram',
        active: true,
      },
      {
        link: 'https://www.pinterest.com/parkosinternational/',
        icon: 'icons-icon-pinterest',
        active: true,
      },
    ],
  }),
  computed: {
    language() {
      return this.$store.state.language;
    },
    twitter() {
      return this.language.socials.twitter;
    },
    facebook() {
      return this.language.socials.facebook;
    },
    youtube() {
      return this.language.socials.youtube;
    },
  },
};
